var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "twitter_2",
    d: "M25.5656 9.98753C25.5781 10.2 25.5781 10.425 25.5781 10.65C25.5781 17.325 20.4281 25.0125 11.0031 25.0125C8.10312 25.0125 5.40313 24.1875 3.14062 22.75C3.55313 22.8 3.95313 22.8125 4.37813 22.8125C6.77813 22.8125 8.97813 22.0125 10.7406 20.6625C8.49063 20.6125 6.60313 19.1625 5.95313 17.1625C6.26563 17.2125 6.59063 17.2375 6.91563 17.2375C7.37813 17.2375 7.84063 17.175 8.26563 17.0625C5.91563 16.5875 4.15312 14.5625 4.15312 12.1125V12.05C4.84062 12.425 5.62813 12.6625 6.46563 12.6875C5.09063 11.775 4.17813 10.2375 4.17813 8.48751C4.17813 7.55001 4.42812 6.68752 4.87812 5.93752C7.40312 9.00002 11.1906 11 15.4406 11.225C15.3656 10.85 15.3156 10.4625 15.3156 10.075C15.3156 7.28752 17.6031 5.02502 20.4406 5.02502C21.9156 5.02502 23.2531 5.63751 24.1781 6.61251C25.3406 6.40001 26.4406 5.97503 27.4281 5.40003C27.0531 6.57503 26.2406 7.56251 25.1781 8.17501C26.2031 8.06251 27.2031 7.78752 28.1281 7.40002C27.4281 8.40002 26.5531 9.28751 25.5531 10.0125L25.5656 9.98753Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.78cf3da50b3d426192a51d8ba22c6eb2.svg";
export { ForwardRef as ReactComponent };